import React from 'react';
import ReactDOM from "react-dom";
import App from './app.js';
import './assets/styles/theme.scss';

ReactDOM.render(<App />, document.getElementById("root"));
